const validId = value => typeof value === 'string' && /^[^/\s]{1,128}$/.test(value) && !['.', '..'].includes(value);

function reject() {
  const error = new Error('The saved Mention response needs review before retrying.');
  error.mentionProcessingFailed = true;
  throw error;
}

/** Recover the committed group before re-evaluating today's remaining history. */
export async function readMentionRuleResult(mention, ruleId, readRecord) {
  const {id, schoolId, studentId} = mention;
  if (![id, schoolId, studentId, ruleId].every(validId)) reject();
  const source = await readRecord('mentions', id);
  if (!source || source.schoolId !== schoolId || source.studentId !== studentId) reject();
  if (!Object.prototype.hasOwnProperty.call(source.mentionRuleResults || {}, ruleId)) return null;
  const receipt = source.mentionRuleResults[ruleId];
  if (receipt?.version !== 1 || !validId(receipt.actionId)) reject();
  const action = await readRecord('disciplineQueue', receipt.actionId);
  if (!action || action.undone === true || action.mentionPersistenceVersion !== 1 || action.schoolId !== schoolId || action.studentId !== studentId ||
      action.ruleType !== 'mention' || action.triggeredByRule !== ruleId ||
      action.phaseContextSource?.collection !== 'mentions' || action.phaseContextSource?.id !== id ||
      !Array.isArray(action.triggeringMentions) || !action.triggeringMentions.length ||
      action.triggeringMentions.length > 450 || !action.triggeringMentions.every(validId)) reject();
  for (const selectedId of action.triggeringMentions) {
    const selected = await readRecord('mentions', selectedId);
    const consumed = selected?.mentionConsumption;
    if (!selected || selected.undone === true || selected.schoolId !== schoolId || selected.studentId !== studentId || selected.actioned !== true ||
        consumed?.version !== 1 || consumed.ruleId !== ruleId || consumed.actionId !== receipt.actionId ||
        consumed.sourceMentionId !== id || !selected.triggeredConsequences?.includes(receipt.actionId)) reject();
  }
  if (action.adjudicationStatus === 'pending') {
    if (!validId(action.adjudicationId)) reject();
    const review = await readRecord('adjudications', action.adjudicationId);
    if (!review || review.schoolId !== schoolId || review.studentId !== studentId ||
        review.sourceType !== 'consequence' || review.sourceId !== receipt.actionId) reject();
  }
  return {...action, id: receipt.actionId};
}

/** Later rules in this same pass must see the server's committed consumption. */
export function applyMentionConsumptionToMemory(records, action) {
  const ids = new Set(action.triggeringMentions || []);
  for (const record of records || []) {
    if (!ids.has(record.id)) continue;
    record.actioned = true;
    record.actionedBy = [...new Set([...(record.actionedBy || []), action.triggeredByRule])];
    record.triggeredConsequences = [...new Set([...(record.triggeredConsequences || []), action.id])];
  }
}
